/**
 * PRODUCT CARD COMPONENT
 * 
 * Individual product display with image, info, and pricing
 */

import React from 'react';
import { TIER_LABELS } from '../../hooks/useProductCatalog';

const ProductCard = ({ product, isSelected, onSelect, markup = 20 }) => {
  const clientPrice = product.cost * (1 + markup / 100);
  const unit = product.unit || '';
  
  return (
    <div
      className={`product-card ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      {/* Selection indicator */}
      {isSelected && (
        <div className="selected-badge">
          <span>✓</span> Selected
        </div>
      )}
      
      {/* Tier badge */}
      <div className={`tier-badge tier-${product.tier}`}>
        {TIER_LABELS[product.tier]}
      </div>
      
      {/* Product image */}
      <div className="product-image">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} />
        ) : (
          <div className="placeholder">📦</div>
        )}
      </div>
      
      {/* Product info */}
      <div className="product-info">
        <p className="product-brand">{product.brand}</p>
        <p className="product-name">{product.name}</p>
        
        {product.specs_display && (
          <p className="product-specs">{product.specs_display}</p>
        )}
        
        <div className="product-price">
          <span className="price-amount">
            ${clientPrice.toFixed(unit ? 2 : 0)}{unit ? `/${unit}` : ''}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
